import React from 'react'
import styled, { css } from 'styled-components'

let PageHeader = styled.h3`
  padding-top: ${(props) => (props.small ? '5px' : '10px')};
  padding-bottom: ${(props) => (props.small ? '5px' : '10px')};

  ${(props) =>
    !props.main &&
    css`
      color: #0056b8;
    `}

  ${(props) =>
    props.large &&
    css`
      font-size: 3em;
    `}
  ${(props) =>
    props.fullWidth &&
    css`
      width: 100%;
    `}
  ${(props) =>
    props.small &&
    css`
      font-size: 1.5em;
    `}
  ${(props) =>
    props.main &&
    css`
      font-weight: bold;
      font-size: 3.5em;
      color: #fff;
    `}
`

const PageHeading = (props) => {
  return (
    <PageHeader main={props.main} fullWidth={props.fullWidth} large={props.large} small={props.small}>
      {props.children}
    </PageHeader>
  )
}

export default PageHeading
